export default __webpack_public_path__ + "static/c3-popup-kerst-2025-895209fce00721a483a541245d1be329.jpg";